function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1944(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 29.66,
    height: 15.65,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.83,
    y: 7.825,
    fontFamily: "Arial"
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 15.65,
    width: 29.66,
    height: 26.58,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.5635294117647058
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.83,
    y: 28.939999999999998,
    fontFamily: "Arial"
  }, "\n        Lake_of_the_Woods\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 42.23,
    width: 29.66,
    height: 33.17,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.83,
    y: 58.815,
    fontFamily: "Arial"
  }, "\n        Mahnomen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 75.4,
    width: 29.66,
    height: 35.43,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.83,
    y: 93.11500000000001,
    fontFamily: "Arial"
  }, "\n        Red_Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 110.83,
    width: 29.66,
    height: 44.49,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.83,
    y: 133.075,
    fontFamily: "Arial"
  }, "\n        Traverse\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 155.31,
    width: 29.66,
    height: 47.54,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.415
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.83,
    y: 179.08,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 202.85,
    width: 29.66,
    height: 51.63,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2955555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.83,
    y: 228.665,
    fontFamily: "Arial"
  }, "\n        Sherburne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 254.49,
    width: 29.66,
    height: 54.5,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.2371428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.83,
    y: 281.74,
    fontFamily: "Arial"
  }, "\n        Kanabec\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 308.98,
    width: 29.66,
    height: 54.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.2371428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.83,
    y: 336.425,
    fontFamily: "Arial"
  }, "\n        Hubbard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 363.88,
    width: 29.66,
    height: 55.07,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2955555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.83,
    y: 391.415,
    fontFamily: "Arial"
  }, "\n        Big_Stone\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 418.95,
    width: 29.66,
    height: 55.14,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.2371428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.83,
    y: 446.52,
    fontFamily: "Arial"
  }, "\n        Kittson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 474.09,
    width: 29.66,
    height: 55.42,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.943333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.83,
    y: 501.79999999999995,
    fontFamily: "Arial"
  }, "\n        Wilkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 529.51,
    width: 29.66,
    height: 56.07,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.966
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.83,
    y: 557.545,
    fontFamily: "Arial"
  }, "\n        Clearwater\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 585.58,
    width: 29.66,
    height: 56.93,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.932
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.83,
    y: 614.0450000000001,
    fontFamily: "Arial"
  }, "\n        Grant\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 642.51,
    width: 29.66,
    height: 57.49,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.2371428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.83,
    y: 671.255,
    fontFamily: "Arial"
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.66,
    y: 0,
    width: 39.83,
    height: 44.62,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.6899999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.575,
    y: 22.31,
    fontFamily: "Arial"
  }, "\n        Stevens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.49,
    y: 0,
    width: 41.57,
    height: 44.62,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.3925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 90.27499999999999,
    y: 22.31,
    fontFamily: "Arial"
  }, "\n        Rock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 111.06,
    y: 0,
    width: 43.78,
    height: 44.62,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.296666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 132.95,
    y: 22.31,
    fontFamily: "Arial"
  }, "\n        Isanti\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154.84,
    y: 0,
    width: 44.27,
    height: 44.62,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.378333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 176.975,
    y: 22.31,
    fontFamily: "Arial"
  }, "\n        Wadena\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 199.11,
    y: 0,
    width: 46.1,
    height: 44.62,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.924
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 222.16000000000003,
    y: 22.31,
    fontFamily: "Arial"
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 245.21,
    y: 0,
    width: 46.52,
    height: 44.62,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.4366666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 268.47,
    y: 22.31,
    fontFamily: "Arial"
  }, "\n        Norman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 291.73,
    y: 0,
    width: 47.86,
    height: 44.62,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.462
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 315.66,
    y: 22.31,
    fontFamily: "Arial"
  }, "\n        Pennington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.59,
    y: 0,
    width: 48.73,
    height: 44.62,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.957777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 363.955,
    y: 22.31,
    fontFamily: "Arial"
  }, "\n        Pipestone\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 388.32,
    y: 0,
    width: 49.78,
    height: 44.62,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.4366666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 413.21,
    y: 22.31,
    fontFamily: "Arial"
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 438.1,
    y: 0,
    width: 51.23,
    height: 44.62,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.4366666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 463.71500000000003,
    y: 22.31,
    fontFamily: "Arial"
  }, "\n        Roseau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 489.32,
    y: 0,
    width: 51.36,
    height: 44.62,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.4366666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 515,
    y: 22.31,
    fontFamily: "Arial"
  }, "\n        Benton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 540.68,
    y: 0,
    width: 52.7,
    height: 44.62,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.155
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 567.03,
    y: 22.31,
    fontFamily: "Arial"
  }, "\n        Pope\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 593.38,
    y: 0,
    width: 53.02,
    height: 44.62,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.374285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 619.89,
    y: 22.31,
    fontFamily: "Arial"
  }, "\n        Chisago\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 646.4,
    y: 0,
    width: 53.6,
    height: 44.62,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.5775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 673.1999999999999,
    y: 22.31,
    fontFamily: "Arial"
  }, "\n        Watonwan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.66,
    y: 44.62,
    width: 51.66,
    height: 46.43,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.738333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.489999999999995,
    y: 67.835,
    fontFamily: "Arial"
  }, "\n        Aitkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.66,
    y: 91.05,
    width: 51.66,
    height: 47.52,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.32
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.489999999999995,
    y: 114.81,
    fontFamily: "Arial"
  }, "\n        Koochiching\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.66,
    y: 138.57,
    width: 51.66,
    height: 48.09,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.809
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.489999999999995,
    y: 162.615,
    fontFamily: "Arial"
  }, "\n        Mille_Lacs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.66,
    y: 186.66,
    width: 51.66,
    height: 49.42,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.1775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.489999999999995,
    y: 211.37,
    fontFamily: "Arial"
  }, "\n        Marshall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.66,
    y: 236.08,
    width: 51.66,
    height: 49.52,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.904
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.489999999999995,
    y: 260.84000000000003,
    fontFamily: "Arial"
  }, "\n        Swift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.66,
    y: 285.6,
    width: 51.66,
    height: 49.72,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8246153846153845
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.489999999999995,
    y: 310.46000000000004,
    fontFamily: "Arial"
  }, "\n        Lac_qui_Parle\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.66,
    y: 335.32,
    width: 51.66,
    height: 49.79,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.112857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.489999999999995,
    y: 360.215,
    fontFamily: "Arial"
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.66,
    y: 385.11,
    width: 51.66,
    height: 50.77,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.461666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.489999999999995,
    y: 410.495,
    fontFamily: "Arial"
  }, "\n        Sibley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.66,
    y: 435.87,
    width: 51.66,
    height: 51.83,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.331999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.489999999999995,
    y: 461.785,
    fontFamily: "Arial"
  }, "\n        Scott\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.66,
    y: 487.7,
    width: 51.66,
    height: 52.5,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.38
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.489999999999995,
    y: 513.95,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.66,
    y: 540.2,
    width: 51.66,
    height: 52.91,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.4575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.489999999999995,
    y: 566.6550000000001,
    fontFamily: "Arial"
  }, "\n        Chippewa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.66,
    y: 593.12,
    width: 51.66,
    height: 53.16,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.1659999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.489999999999995,
    y: 619.7,
    fontFamily: "Arial"
  }, "\n        Cottonwood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.66,
    y: 646.28,
    width: 51.66,
    height: 53.72,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.61
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 55.489999999999995,
    y: 673.14,
    fontFamily: "Arial"
  }, "\n        Waseca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.32,
    y: 44.62,
    width: 50.1,
    height: 56.89,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.36999999999999,
    y: 73.065,
    fontFamily: "Arial"
  }, "\n        Cass\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 131.43,
    y: 44.62,
    width: 50.39,
    height: 56.89,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3593333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 156.625,
    y: 73.065,
    fontFamily: "Arial"
  }, "\n        Yellow_Medicine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181.82,
    y: 44.62,
    width: 51.29,
    height: 56.89,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.41125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 207.465,
    y: 73.065,
    fontFamily: "Arial"
  }, "\n        Nicollet\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 233.11,
    y: 44.62,
    width: 51.49,
    height: 56.89,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.355714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 258.855,
    y: 73.065,
    fontFamily: "Arial"
  }, "\n        Wabasha\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 284.6,
    y: 44.62,
    width: 56.88,
    height: 56.89,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.48
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 313.04,
    y: 73.065,
    fontFamily: "Arial"
  }, "\n        Carver\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341.48,
    y: 44.62,
    width: 57.44,
    height: 56.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.481666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 370.20000000000005,
    y: 73.065,
    fontFamily: "Arial"
  }, "\n        Meeker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 398.92,
    y: 44.62,
    width: 58.14,
    height: 56.89,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.481666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 427.99,
    y: 73.065,
    fontFamily: "Arial"
  }, "\n        Nobles\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 457.06,
    y: 44.62,
    width: 59.91,
    height: 56.89,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.2225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 487.015,
    y: 73.065,
    fontFamily: "Arial"
  }, "\n        Pine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 516.97,
    y: 44.62,
    width: 60.21,
    height: 56.89,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.127142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 547.075,
    y: 73.065,
    fontFamily: "Arial"
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 577.18,
    y: 44.62,
    width: 60.97,
    height: 56.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.11125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 607.665,
    y: 73.065,
    fontFamily: "Arial"
  }, "\n        Le_Sueur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 638.15,
    y: 44.62,
    width: 61.85,
    height: 56.89,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.481666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 669.0749999999999,
    y: 73.065,
    fontFamily: "Arial"
  }, "\n        Steele\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.32,
    y: 101.51,
    width: 63.86,
    height: 56.28,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.035
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.25,
    y: 129.65,
    fontFamily: "Arial"
  }, "\n        Beltrami\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.32,
    y: 157.79,
    width: 63.86,
    height: 56.55,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.1375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.25,
    y: 186.065,
    fontFamily: "Arial"
  }, "\n        Lyon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.32,
    y: 214.34,
    width: 63.86,
    height: 56.87,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.124285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.25,
    y: 242.775,
    fontFamily: "Arial"
  }, "\n        Redwood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.32,
    y: 271.21,
    width: 63.86,
    height: 57,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.5
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.25,
    y: 299.71,
    fontFamily: "Arial"
  }, "\n        McLeod\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.32,
    y: 328.21,
    width: 63.86,
    height: 59.65,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.941666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.25,
    y: 358.03499999999997,
    fontFamily: "Arial"
  }, "\n        Becker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.32,
    y: 387.86,
    width: 63.86,
    height: 60.37,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.624285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.25,
    y: 418.045,
    fontFamily: "Arial"
  }, "\n        Carlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.32,
    y: 448.23,
    width: 63.86,
    height: 61.19,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.64875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.25,
    y: 478.82500000000005,
    fontFamily: "Arial"
  }, "\n        Renville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.32,
    y: 509.42,
    width: 63.86,
    height: 61.37,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.67125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.25,
    y: 540.105,
    fontFamily: "Arial"
  }, "\n        Morrison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.32,
    y: 570.78,
    width: 63.86,
    height: 64.54,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.772
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.25,
    y: 603.05,
    fontFamily: "Arial"
  }, "\n        Anoka\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.32,
    y: 635.33,
    width: 63.86,
    height: 64.67,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.095555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.25,
    y: 667.6650000000001,
    fontFamily: "Arial"
  }, "\n        Faribault\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.19,
    y: 101.51,
    width: 66.28,
    height: 62.35,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.5875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.32999999999998,
    y: 132.685,
    fontFamily: "Arial"
  }, "\n        Todd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.47,
    y: 101.51,
    width: 66.76,
    height: 62.35,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.79375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 244.85,
    y: 132.685,
    fontFamily: "Arial"
  }, "\n        Fillmore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.23,
    y: 101.51,
    width: 67.4,
    height: 62.35,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.391666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 311.93,
    y: 132.685,
    fontFamily: "Arial"
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 345.63,
    y: 101.51,
    width: 67.54,
    height: 62.35,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.5875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 379.4,
    y: 132.685,
    fontFamily: "Arial"
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 413.18,
    y: 101.51,
    width: 69.46,
    height: 62.35,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.47
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 447.91,
    y: 132.685,
    fontFamily: "Arial"
  }, "\n        Brown\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 482.64,
    y: 101.51,
    width: 70.29,
    height: 62.35,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.927777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 517.785,
    y: 132.685,
    fontFamily: "Arial"
  }, "\n        Crow_Wing\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 552.93,
    y: 101.51,
    width: 72.29,
    height: 62.35,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.927777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 589.0749999999999,
    y: 132.685,
    fontFamily: "Arial"
  }, "\n        Kandiyohi\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 625.22,
    y: 101.51,
    width: 74.78,
    height: 62.35,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.391666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 662.61,
    y: 132.685,
    fontFamily: "Arial"
  }, "\n        Wright\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.19,
    y: 163.86,
    width: 72.4,
    height: 68.08,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.02
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 181.39,
    y: 197.9,
    fontFamily: "Arial"
  }, "\n        Rice\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.19,
    y: 231.94,
    width: 72.4,
    height: 70.22,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.022
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 181.39,
    y: 267.05,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.19,
    y: 302.16,
    width: 72.4,
    height: 73.63,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.05
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 181.39,
    y: 338.975,
    fontFamily: "Arial"
  }, "\n        Freeborn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.19,
    y: 375.79,
    width: 72.4,
    height: 78.74,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.066666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 181.39,
    y: 415.16,
    fontFamily: "Arial"
  }, "\n        Itasca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.19,
    y: 454.53,
    width: 72.4,
    height: 80.03,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.1
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 181.39,
    y: 494.54499999999996,
    fontFamily: "Arial"
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.19,
    y: 534.56,
    width: 72.4,
    height: 82.25,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.342857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 181.39,
    y: 575.685,
    fontFamily: "Arial"
  }, "\n        Goodhue\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145.19,
    y: 616.81,
    width: 72.4,
    height: 83.19,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.48
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 181.39,
    y: 658.405,
    fontFamily: "Arial"
  }, "\n        Mower\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 217.59,
    y: 163.86,
    width: 69.23,
    height: 91.22,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.538333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 252.205,
    y: 209.47000000000003,
    fontFamily: "Arial"
  }, "\n        Winona\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 286.82,
    y: 163.86,
    width: 69.59,
    height: 91.22,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.9590000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 321.615,
    y: 209.47000000000003,
    fontFamily: "Arial"
  }, "\n        Blue_Earth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 356.41,
    y: 163.86,
    width: 72.9,
    height: 91.22,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.414285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 392.86,
    y: 209.47000000000003,
    fontFamily: "Arial"
  }, "\n        Olmsted\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 429.31,
    y: 163.86,
    width: 78.29,
    height: 91.22,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.048333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 468.455,
    y: 209.47000000000003,
    fontFamily: "Arial"
  }, "\n        Dakota\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 507.6,
    y: 163.86,
    width: 87.26,
    height: 91.22,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.726
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 551.23,
    y: 209.47000000000003,
    fontFamily: "Arial"
  }, "\n        Otter_Tail\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 594.86,
    y: 163.86,
    width: 105.14,
    height: 91.22,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.031428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 647.4300000000001,
    y: 209.47000000000003,
    fontFamily: "Arial"
  }, "\n        Stearns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 217.59,
    y: 255.08,
    width: 220.84,
    height: 181.26,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.478181818181817
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 328.01,
    y: 345.71000000000004,
    fontFamily: "Arial"
  }, "\n        Saint_Louis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 217.59,
    y: 436.34,
    width: 220.84,
    height: 263.66,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 36.806666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 328.01,
    y: 568.17,
    fontFamily: "Arial"
  }, "\n        Ramsey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 438.43,
    y: 255.08,
    width: 261.57,
    height: 444.92,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 32.69625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 569.215,
    y: 477.54,
    fontFamily: "Arial"
  }, "\n        Hennepin\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1944);
export default __webpack_public_path__ + "static/media/1944.9182107acafa4e01db9c31fef188925e.svg";
export { ForwardRef as ReactComponent };